module.exports = __webpack_public_path__ + "static/media/rgfba-sig.1415e52c.jpg";